import EventPlay from './EventPlay'
export default EventPlay